export const CLIPBOARD_AVAILABLE = navigator.clipboard && window.isSecureContext;

export const APPLICATION_GRAPH_POSITION_STORAGE_KEY = 'application-graph-positions';
export const LAST_WORKSPACE_ID = 'last-workspace-id';
export const LAST_WORKSPACE_IDS = 'last-workspace-ids';

export const WORKSPACE_MENU_RECEIVER_ID = 'WorkspaceMenuReceiver';

export const ROLES = [{
  label: 'User',
  id: 'USER',
}, {
  label: 'Admin',
  id: 'ADMIN',
}, {
  label: 'Agent',
  id: 'AGENT',
}];

const USER_MANGEMENT_ROLE_IDS = ['USER', 'ADMIN'];

export const USER_MANGEMENT_ROLES = ROLES.filter(({id}) => USER_MANGEMENT_ROLE_IDS.includes(id));

export const SEARCH_NODE = 'UnresolvedReference';

export const STORAGE_HELP_TEXT_SHOWN_KEY = 'release-assistant-show-help-text';

export const DATE_FORMAT = 'YYYY-MM-DD';
export const DATETIME_FORMAT = 'YYYY-MM-DD hh:mm Z';
